import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { iterationService } from "../services/iteration.service";

export const createIteration = createAsyncThunk("createIteration", async ({data}, { rejectWithValue }) => {
    try {
        return await iterationService.createIteration(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getIterationList = createAsyncThunk("getIterationList", async (params, { rejectWithValue }) => {
    try {
        return await iterationService.getIterationList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getIteration = createAsyncThunk("getIteration", async (id, { rejectWithValue }) => {
    try {
        return await iterationService.getIteration(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateIteration = createAsyncThunk("updateIteration", async ({data,id}, { rejectWithValue }) => {
    try {
        return await iterationService.updateIteration(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deleteIteration = createAsyncThunk("deleteIteration", async (id, { rejectWithValue }) => {
    try {
        return await iterationService.deleteIteration(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateIterationStatus = createAsyncThunk("updateIterationStatus", async (data, { rejectWithValue }) => {
    try {
        return await iterationService.updateIterationStatus(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

const iterationSlice = createSlice({
    name: "pmo-iteration",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        detail: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        create: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        update: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        delete: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        status: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        }
    },
    reducers: {
        resetStateIteration: (state) => {
            state.list.isError = false;
            state.list.message = null;
            state.detail.isError = false;
            state.detail.message = null;
            state.create.isError = false;
            state.create.message = null;
            state.create.data = null;
            state.update.isError = false;
            state.update.message = null;
            state.update.data = null;
            state.delete.isError = false;
            state.delete.message = null;
            state.delete.data = null;
            state.status.isError = false;
            state.status.message = null;
            state.status.data = null;
        },
    },
    extraReducers: (builder) => {
        // get iteration list
        builder.addCase(getIterationList.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(getIterationList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getIterationList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload?.message;
        });

        // get iteration detail
        builder.addCase(getIteration.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getIteration.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getIteration.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload?.message;
        });

        // create iteration
        builder.addCase(createIteration.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createIteration.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createIteration.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload?.message;
        });

        // update iteration
        builder.addCase(updateIteration.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updateIteration.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updateIteration.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload?.message;
        });

        // delete iteration
        builder.addCase(deleteIteration.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deleteIteration.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deleteIteration.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload?.message;
        });

        // update iteration status
        builder.addCase(updateIterationStatus.pending, (state) => {
            state.status.isLoading = true;
        });
        builder.addCase(updateIterationStatus.fulfilled, (state, action) => {
            state.status.isLoading = false;
            state.status.data = action.payload;
            state.status.isError = false;
        });
        builder.addCase(updateIterationStatus.rejected, (state, action) => {
            state.status.isLoading = false;
            state.status.isError = true;
            state.status.message = action.payload?.message;
        });
    },
});

export const { resetStateIteration } = iterationSlice.actions;
export default iterationSlice.reducer;
